import { render, staticRenderFns } from "./ChecklistsOverview.vue?vue&type=template&id=27bdea0f"
import script from "./ChecklistsOverview.vue?vue&type=script&lang=ts"
export * from "./ChecklistsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports